import styled from 'styled-components';
import TopBarStyle from '../TopBar/TopBarStyle';
import { getValueFromTheme } from '../../utils';
const HeaderStyle = styled(TopBarStyle) `
  flex-wrap: nowrap;
  height: 100%;
  margin: 0 auto;
  padding: 0 10px;
  align-items: stretch;
  max-width: ${({ fullWidth, theme }) => fullWidth ? 'none' : `${getValueFromTheme('maxGridWidth')({ theme })}px`};
`;
export default HeaderStyle;
//# sourceMappingURL=HeaderStyle.js.map